// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T1JsHQav{display:flex;height:100%}.WWNMpd9G{flex:1;display:flex;flex-direction:column;gap:var(--space);padding-right:calc(var(--space)*2)}.WWNMpd9G+.WWNMpd9G{border-left:1px solid var(--theme-border-muted);padding-left:calc(var(--space)*2);padding-right:0}.d1asjFro{max-height:calc(100% - 120px)}.GD7dgJEf{height:calc(100% - 4rem)}`, "",{"version":3,"sources":["webpack://./src/page-components/intent/LinkIntentHierarchy.module.scss"],"names":[],"mappings":"AAAA,UACE,YAAA,CACA,WAAA,CAGF,UACE,MAAA,CACA,YAAA,CACA,qBAAA,CACA,gBAAA,CACA,kCAAA,CAEA,oBACE,+CAAA,CACA,iCAAA,CACA,eAAA,CAIJ,UACE,6BAAA,CAGF,UACE,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `T1JsHQav`,
	"column": `WWNMpd9G`,
	"list": `d1asjFro`,
	"listContainer": `GD7dgJEf`
};
export default ___CSS_LOADER_EXPORT___;
